// 크리에이터 방문 커미션 시스템 — 크리에이터 온보딩/대시보드, 업체 제휴관리 탭, QR 랜딩, 어드민 화면.
// ko/en/vi/ru 4개 언어(기존 phase partial 컨벤션과 동일).

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, v]) => {
    out[k] = Array.isArray(v) ? v[langIndex] : v;
  });
  return out;
}

const onboarding = {
  title: ['크리에이터 신청', 'Become a creator', 'Trở thành creator', 'Стать создателем'],
  desc: [
    '업체 방문을 유도하는 콘텐츠를 만들고 방문당 커미션을 받으세요.',
    'Create content that drives visits and earn a commission per visit.',
    'Tạo nội dung thu hút khách đến cửa hàng và nhận hoa hồng theo lượt ghé thăm.',
    'Создавайте контент, привлекающий посетителей, и получайте комиссию за каждый визит.',
  ],
  nameLabel: ['활동명', 'Display name', 'Tên hiển thị', 'Отображаемое имя'],
  namePlaceholder: ['닉네임/채널명', 'Nickname / channel name', 'Biệt danh / tên kênh', 'Никнейм / название канала'],
  nameRequired: ['활동명을 입력해 주세요.', 'Please enter a display name.', 'Vui lòng nhập tên hiển thị.', 'Пожалуйста, введите отображаемое имя.'],
  prefillNote: [
    '내정보(이름/소개/지역)를 불러왔어요. 필요하면 자유롭게 수정하세요.',
    'We filled this in from your profile (name/bio/city). Feel free to edit it.',
    'Đã lấy thông tin từ hồ sơ của bạn (tên/giới thiệu/khu vực). Bạn có thể chỉnh sửa tùy ý.',
    'Мы заполнили это на основе вашего профиля (имя/о себе/город). Вы можете изменить.',
  ],
  refetchBtn: ['다시 불러오기', 'Reload from profile', 'Lấy lại từ hồ sơ', 'Обновить из профиля'],
  bioLabel: ['소개', 'Bio', 'Giới thiệu', 'О себе'],
  bioPlaceholder: ['간단한 소개를 적어주세요', 'A short introduction', 'Giới thiệu ngắn gọn', 'Краткое описание'],
  typeLabel: ['콘텐츠 유형', 'Content type', 'Loại nội dung', 'Тип контента'],
  cityLabel: ['활동 지역', 'City', 'Thành phố', 'Город'],
  followerLabel: ['팔로워 수', 'Follower count', 'Số người theo dõi', 'Количество подписчиков'],
  submitBtn: ['신청하기', 'Apply', 'Gửi đăng ký', 'Подать заявку'],
  submitted: ['신청이 접수됐어요. 검토 후 알려드릴게요.', 'Application submitted. We will review it soon.', 'Đã gửi đăng ký. Chúng tôi sẽ xem xét sớm.', 'Заявка отправлена. Мы скоро её рассмотрим.'],
  submitFail: ['신청에 실패했어요.', 'Failed to submit application.', 'Gửi đăng ký thất bại.', 'Не удалось отправить заявку.'],
};

const onboardingType = {
  video: ['영상', 'Video', 'Video ngắn', 'Видео'],
  photo: ['사진', 'Photo', 'Ảnh', 'Фото'],
  blog: ['블로그', 'Blog', 'Nhật ký blog', 'Блог'],
  mixed: ['혼합', 'Mixed', 'Kết hợp', 'Смешанный'],
};

const pending = {
  title: ['심사 중이에요', 'Under review', 'Đang xét duyệt', 'На рассмотрении'],
  desc: [
    '크리에이터 신청을 검토하고 있어요. 승인되면 알려드릴게요.',
    'Your creator application is being reviewed. We will notify you once approved.',
    'Đăng ký creator của bạn đang được xem xét. Chúng tôi sẽ thông báo khi được duyệt.',
    'Ваша заявка на роль создателя рассматривается. Мы сообщим, когда она будет одобрена.',
  ],
};

const rejected = {
  title: ['신청이 반려됐어요', 'Application rejected', 'Đăng ký bị từ chối', 'Заявка отклонена'],
  retryBtn: ['다시 신청하기', 'Apply again', 'Đăng ký lại', 'Подать заявку снова'],
};

const linkRequest = {
  title: ['업체에 제휴 신청', 'Request a partnership', 'Yêu cầu hợp tác với cửa hàng', 'Запросить партнёрство с бизнесом'],
  searchPlaceholder: ['업체 이름 검색', 'Search business name', 'Tìm tên cửa hàng', 'Поиск по названию бизнеса'],
  contentUrlLabel: ['콘텐츠 링크 (선택)', 'Content link (optional)', 'Liên kết nội dung (tuỳ chọn)', 'Ссылка на контент (необязательно)'],
  messageLabel: ['메시지', 'Message', 'Tin nhắn', 'Сообщение'],
  sendBtn: ['{name}에 제휴 신청', 'Request {name}', 'Yêu cầu hợp tác {name}', 'Запросить {name}'],
  sent: ['제휴 신청을 보냈어요.', 'Partnership request sent.', 'Đã gửi yêu cầu hợp tác.', 'Запрос на партнёрство отправлен.'],
  sendFail: ['신청에 실패했어요.', 'Failed to send request.', 'Gửi yêu cầu thất bại.', 'Не удалось отправить запрос.'],
};

const links = {
  title: ['내 제휴 업체', 'My partnerships', 'Cửa hàng hợp tác của tôi', 'Мои партнёрства'],
  empty: ['아직 제휴한 업체가 없어요.', 'No partnerships yet.', 'Chưa có cửa hàng hợp tác.', 'Пока нет партнёрств.'],
  unknownBusiness: ['업체', 'Business', 'Cửa hàng', 'Бизнес'],
  commissionFlat: ['방문당 {value} 크레딧', '{value} credits per visit', '{value} credit mỗi lượt ghé', '{value} кредитов за визит'],
  commissionPercent: ['청구금액의 {value}%', '{value}% of bill amount', '{value}% giá trị hóa đơn', '{value}% от суммы счёта'],
  copyLink: ['링크 복사', 'Copy link', 'Sao chép liên kết', 'Скопировать ссылку'],
  copied: ['복사됐어요!', 'Copied!', 'Đã sao chép!', 'Скопировано!'],
};

const linkStatus = {
  requested: ['요청중', 'Requested', 'Đã yêu cầu', 'Запрошено'],
  approved: ['승인됨', 'Approved', 'Đã duyệt', 'Одобрено'],
  rejected: ['반려됨', 'Rejected', 'Bị từ chối', 'Отклонено'],
  ended: ['종료됨', 'Ended', 'Đã kết thúc', 'Завершено'],
};

const earnings = {
  title: ['수익 현황', 'Earnings', 'Thu nhập', 'Доход'],
  available: ['정산 가능', 'Available', 'Có thể rút', 'Доступно'],
  total: ['누적 수익', 'Total earned', 'Tổng thu nhập', 'Всего заработано'],
};

const settlementNs = {
  requestBtn: ['정산 요청', 'Request payout', 'Yêu cầu rút tiền', 'Запросить выплату'],
  methodLabel: ['지급 방식', 'Payment method', 'Phương thức thanh toán', 'Способ выплаты'],
  methodBank: ['계좌이체', 'Bank transfer', 'Chuyển khoản ngân hàng', 'Банковский перевод'],
  methodMomo: ['모모(Momo)', 'Momo', 'Ví Momo', 'Кошелёк Momo'],
  methodOther: ['기타', 'Other', 'Khác', 'Другое'],
  accountLabel: ['계좌/수령 정보', 'Account info', 'Thông tin tài khoản', 'Платёжные реквизиты'],
  accountPlaceholder: ['은행명, 예금주, 계좌번호', 'Bank, account holder, account number', 'Ngân hàng, chủ tài khoản, số tài khoản', 'Банк, владелец счёта, номер счёта'],
  accountRequired: ['계좌 정보를 입력해 주세요.', 'Please enter account info.', 'Vui lòng nhập thông tin tài khoản.', 'Пожалуйста, укажите платёжные реквизиты.'],
  memoLabel: ['메모 (선택)', 'Memo (optional)', 'Ghi chú (tuỳ chọn)', 'Заметка (необязательно)'],
  submitBtn: ['요청 보내기', 'Submit request', 'Gửi yêu cầu', 'Отправить запрос'],
  requested: ['정산을 요청했어요.', 'Payout requested.', 'Đã yêu cầu rút tiền.', 'Запрос на выплату отправлен.'],
  requestFail: ['정산 요청에 실패했어요.', 'Failed to request payout.', 'Yêu cầu rút tiền thất bại.', 'Не удалось запросить выплату.'],
  estimateNote: ['예상 환산액(참고용, 실제 지급액은 지급 처리 시점 환율로 확정):', 'Estimated conversion (reference only — final amount is locked when paid):', 'Số tiền quy đổi ước tính (chỉ để tham khảo — số tiền cuối cùng được chốt khi thanh toán):', 'Примерная конвертация (только для справки — итоговая сумма фиксируется при выплате):'],
  businessNumberRequired: ['사업자등록번호를 입력해 주세요.', 'Please enter a business registration number.', 'Vui lòng nhập mã số đăng ký kinh doanh.', 'Пожалуйста, укажите номер регистрации бизнеса.'],
  businessInfoTitle: ['정산 신청 전 사업자정보 등록', 'Register business info before requesting payout', 'Đăng ký thông tin doanh nghiệp trước khi yêu cầu thanh toán', 'Зарегистрируйте данные бизнеса перед запросом выплаты'],
  businessInfoDesc: [
    '한국 서비스 기준이라 정산 신청 시 사업자등록번호가 필요해요. 세무 신고 목적으로만 사용돼요.',
    'Since this is a Korea-based service, a business registration number is required to request a payout. Used for tax reporting only.',
    'Vì đây là dịch vụ dựa trên Hàn Quốc, cần có mã số đăng ký kinh doanh để yêu cầu thanh toán. Chỉ dùng cho mục đích khai thuế.',
    'Поскольку это корейский сервис, для запроса выплаты требуется номер регистрации бизнеса. Используется только для налоговой отчётности.',
  ],
  businessNumberLabel: ['사업자등록번호', 'Business registration number', 'Mã số đăng ký kinh doanh', 'Номер регистрации бизнеса'],
  businessNumberPlaceholder: ['예: 123-45-67890', '000-00-00000', 'VD: 123-45-67890', 'Напр.: 123-45-67890'],
  businessNameLabel: ['상호(선택)', 'Business name (optional)', 'Tên doanh nghiệp (tuỳ chọn)', 'Название компании (необязательно)'],
  businessOwnerLabel: ['대표자명(선택)', 'Owner name (optional)', 'Tên chủ sở hữu (tuỳ chọn)', 'Имя владельца (необязательно)'],
  businessInfoSaveBtn: ['저장하고 계속', 'Save and continue', 'Lưu và tiếp tục', 'Сохранить и продолжить'],
  businessInfoSaved: ['사업자정보를 저장했어요.', 'Business info saved.', 'Đã lưu thông tin doanh nghiệp.', 'Данные бизнеса сохранены.'],
  payoutCurrencyLabel: ['지급받을 통화', 'Payout currency', 'Đơn vị tiền tệ nhận thanh toán', 'Валюта выплаты'],
  payoutCurrencyNote: [
    '실제 지급액은 지급 처리 시점 환율과 원천징수를 반영해 확정돼요.',
    'The final payout reflects the exchange rate and any withholding tax at the time of payment.',
    'Số tiền thanh toán cuối cùng phản ánh tỷ giá và thuế khấu trừ tại thời điểm thanh toán.',
    'Итоговая выплата учитывает курс обмена и удержанный налог на момент выплаты.',
  ],
  payoutAmountLabel: ['실지급액', 'Payout amount', 'Số tiền thực nhận', 'Сумма к выплате'],
  withholdingLabel: ['원천징수', 'Withholding', 'Khấu trừ thuế', 'Удержанный налог'],
};

const settlementStatus = {
  pending: ['대기중', 'Pending', 'Đang chờ', 'В ожидании'],
  approved: ['승인됨', 'Approved', 'Đã duyệt', 'Одобрено'],
  rejected: ['반려됨', 'Rejected', 'Bị từ chối', 'Отклонено'],
  paid: ['지급완료', 'Paid', 'Đã thanh toán', 'Выплачено'],
};

const qrLanding = {
  notFound: ['유효하지 않은 링크예요.', 'This link is not valid.', 'Liên kết không hợp lệ.', 'Эта ссылка недействительна.'],
  genericError: ['오류가 발생했어요. 다시 시도해 주세요.', 'Something went wrong. Please try again.', 'Đã xảy ra lỗi. Vui lòng thử lại.', 'Произошла ошибка. Попробуйте снова.'],
  viaCreator: ['{name}님의 추천으로 오셨네요', 'You came via {name}', 'Bạn đến qua giới thiệu của {name}', 'Вы пришли по рекомендации {name}'],
  showStaffHint: ['이 화면을 매장 직원에게 보여주세요', 'Show this screen to the staff', 'Vui lòng cho nhân viên xem màn hình này', 'Покажите этот экран сотруднику'],
};

const bizRequests = {
  title: ['제휴 요청', 'Partnership requests', 'Yêu cầu hợp tác', 'Запросы на партнёрство'],
  empty: ['대기중인 요청이 없어요.', 'No pending requests.', 'Không có yêu cầu đang chờ.', 'Нет запросов в ожидании.'],
  reviewBtn: ['검토하기', 'Review', 'Xem xét', 'Рассмотреть'],
  followers: ['팔로워 {count}명', '{count} followers', '{count} người theo dõi', '{count} подписчиков'],
  commissionTypeLabel: ['커미션 방식', 'Commission type', 'Loại hoa hồng', 'Тип комиссии'],
  commissionTypeFlat: ['건당 고정', 'Flat per visit', 'Cố định mỗi lượt', 'Фиксированная за визит'],
  commissionTypePercent: ['청구금액 비율(%)', '% of bill amount', '% giá trị hóa đơn', '% от суммы счёта'],
  commissionValueFlatLabel: ['방문당 크레딧', 'Credits per visit', 'Credit mỗi lượt ghé', 'Кредитов за визит'],
  commissionValuePercentLabel: ['비율(%)', 'Percent (%)', 'Tỷ lệ (%)', 'Процент (%)'],
  benefitLabel: ['고객 혜택', 'Customer benefit', 'Ưu đãi khách hàng', 'Выгода для клиента'],
  benefitPlaceholder: ['예: 무료 음료 1잔', 'e.g. 1 free drink', 'VD: 1 đồ uống miễn phí', 'напр. 1 бесплатный напиток'],
  approveBtn: ['승인', 'Approve', 'Duyệt', 'Одобрить'],
  rejectBtn: ['거절', 'Reject', 'Từ chối', 'Отклонить'],
  valueRequired: ['커미션 금액을 입력해 주세요.', 'Please enter a commission value.', 'Vui lòng nhập giá trị hoa hồng.', 'Пожалуйста, укажите размер комиссии.'],
  approved: ['제휴를 승인했어요.', 'Partnership approved.', 'Đã duyệt hợp tác.', 'Партнёрство одобрено.'],
  approveFail: ['승인에 실패했어요.', 'Failed to approve.', 'Duyệt thất bại.', 'Не удалось одобрить.'],
  rejected: ['제휴를 거절했어요.', 'Partnership rejected.', 'Đã từ chối hợp tác.', 'Партнёрство отклонено.'],
  rejectFail: ['거절에 실패했어요.', 'Failed to reject.', 'Từ chối thất bại.', 'Не удалось отклонить.'],
  defaultRejectReason: ['업체 사정으로 거절됐어요.', 'Rejected by the business.', 'Bị từ chối bởi cửa hàng.', 'Отклонено бизнесом.'],
};

const bizClaims = {
  title: ['방문 확인 대기중', 'Visits awaiting confirmation', 'Lượt ghé thăm đang chờ xác nhận', 'Визиты, ожидающие подтверждения'],
  billAmountLabel: ['실제 결제 금액', 'Actual bill amount', 'Số tiền thanh toán thực tế', 'Фактическая сумма счёта'],
  billAmountRequired: ['결제 금액을 입력해 주세요.', 'Please enter the bill amount.', 'Vui lòng nhập số tiền thanh toán.', 'Пожалуйста, укажите сумму счёта.'],
  confirmBtn: ['방문 확인', 'Confirm visit', 'Xác nhận lượt ghé', 'Подтвердить визит'],
  rejectBtn: ['거절', 'Reject', 'Từ chối', 'Отклонить'],
  confirmed: ['방문을 확인했어요.', 'Visit confirmed.', 'Đã xác nhận lượt ghé.', 'Визит подтверждён.'],
  rejected: ['거절했어요.', 'Rejected.', 'Đã từ chối.', 'Отклонено.'],
  actionFail: ['처리에 실패했어요.', 'Action failed.', 'Xử lý thất bại.', 'Действие не выполнено.'],
  insufficientCredit: [
    '크레딧이 부족해서 확정할 수 없어요. 충전 후 다시 시도해 주세요.',
    'Not enough credits to confirm. Please top up and try again.',
    'Không đủ credit để xác nhận. Vui lòng nạp thêm rồi thử lại.',
    'Недостаточно кредитов для подтверждения. Пополните баланс и попробуйте снова.',
  ],
  shortfallNote: [
    '{needed} 크레딧이 필요한데 잔액은 {balance} 크레딧이에요.',
    'This needs {needed} credits, but your balance is {balance}.',
    'Cần {needed} credit, nhưng số dư hiện tại là {balance}.',
    'Нужно {needed} кредитов, но на балансе {balance}.',
  ],
  topupBtn: ['충전하러 가기', 'Top up credits', 'Nạp credit', 'Пополнить баланс'],
};

const bizActive = {
  title: ['활성 파트너', 'Active partners', 'Đối tác đang hoạt động', 'Активные партнёры'],
  empty: ['활성 파트너가 없어요.', 'No active partners.', 'Không có đối tác đang hoạt động.', 'Нет активных партнёров.'],
  commissionFlat: ['방문당 {value} 크레딧', '{value} credits per visit', '{value} credit mỗi lượt ghé', '{value} кредитов за визит'],
  commissionPercent: ['청구금액의 {value}%', '{value}% of bill amount', '{value}% giá trị hóa đơn', '{value}% от суммы счёта'],
};

const bizProfile = {
  verifiedBadge: ['인증됨', 'Verified', 'Đã xác minh', 'Проверено'],
  viewSampleLink: ['콘텐츠 샘플 보기', 'View content sample', 'Xem mẫu nội dung', 'Смотреть образец контента'],
};

const bizSummary = {
  title: ['이번달 크리에이터 지출', "This month's creator spend", 'Chi tiêu creator tháng này', 'Расходы на создателей за этот месяц'],
  monthSpend: ['이번달 사용 크레딧', 'Credits spent this month', 'Credit đã dùng tháng này', 'Потрачено кредитов в этом месяце'],
  creditBalance: ['보유 크레딧', 'Credit balance', 'Số dư credit', 'Баланс кредитов'],
};

const adminCreators = {
  pageTitle: ['크리에이터 관리', 'Creator management', 'Quản lý creator', 'Управление создателями'],
  pageDesc: ['크리에이터 신청 심사, 전체 현황, 정산 요청을 관리합니다.', 'Review creator applications, view overview, and manage payouts.', 'Xét duyệt đăng ký creator, xem tổng quan và quản lý thanh toán.', 'Рассматривайте заявки создателей, просматривайте обзор и управляйте выплатами.'],
  noApplications: ['대기중인 신청이 없어요.', 'No pending applications.', 'Không có đăng ký đang chờ.', 'Нет заявок в ожидании.'],
  noCreators: ['크리에이터가 없어요.', 'No creators yet.', 'Chưa có creator.', 'Пока нет создателей.'],
  noSettlements: ['대기중인 정산 요청이 없어요.', 'No pending payout requests.', 'Không có yêu cầu thanh toán đang chờ.', 'Нет запросов на выплату в ожидании.'],
  followers: ['팔로워 {n}명', '{n} followers', '{n} người theo dõi', '{n} подписчиков'],
  approveBtn: ['승인', 'Approve', 'Duyệt', 'Одобрить'],
  rejectBtn: ['거절', 'Reject', 'Từ chối', 'Отклонить'],
  markPaidBtn: ['지급완료 처리', 'Mark as paid', 'Đánh dấu đã thanh toán', 'Отметить как выплаченное'],
  rejectReasonPrompt: ['반려 사유(선택)', 'Reason for rejection (optional)', 'Lý do từ chối (tuỳ chọn)', 'Причина отклонения (необязательно)'],
  actionFailed: ['처리에 실패했어요.', 'Action failed.', 'Xử lý thất bại.', 'Действие не выполнено.'],
  confirmMarkPaid: ['지급완료로 처리할까요?', 'Mark this as paid?', 'Đánh dấu là đã thanh toán?', 'Отметить как выплаченное?'],
};

const adminCreatorStatus = {
  pending: ['대기중', 'Pending', 'Đang chờ', 'В ожидании'],
  approved: ['승인됨', 'Approved', 'Đã duyệt', 'Одобрено'],
  rejected: ['반려됨', 'Rejected', 'Bị từ chối', 'Отклонено'],
  suspended: ['정지됨', 'Suspended', 'Bị đình chỉ', 'Приостановлено'],
};

const suspendedNs = {
  title: ['크리에이터 자격이 정지됐어요', 'Your creator status is suspended', 'Tư cách creator của bạn đã bị đình chỉ', 'Ваш статус создателя приостановлен'],
  desc: [
    '신고 또는 정책 위반으로 자격이 정지됐어요. 문의는 고객센터로 연락해 주세요.',
    'Your account was suspended due to a report or policy violation. Please contact support.',
    'Tài khoản của bạn đã bị đình chỉ do bị báo cáo hoặc vi phạm chính sách. Vui lòng liên hệ bộ phận hỗ trợ.',
    'Ваш аккаунт приостановлен из-за жалобы или нарушения правил. Обратитесь в поддержку.',
  ],
};

const claimStatus = {
  pending: ['확인대기', 'Pending', 'Đang chờ xác nhận', 'Ожидает подтверждения'],
  confirmed: ['적립완료', 'Confirmed', 'Đã xác nhận', 'Подтверждено'],
  rejected: ['거절됨', 'Rejected', 'Bị từ chối', 'Отклонено'],
  expired: ['만료됨', 'Expired', 'Đã hết hạn', 'Истёк срок'],
  disputed: ['이의제기중', 'Under dispute', 'Đang khiếu nại', 'На рассмотрении спора'],
};

const dispute = {
  reasonRequired: ['사유를 입력해 주세요.', 'Please enter a reason.', 'Vui lòng nhập lý do.', 'Пожалуйста, укажите причину.'],
  submitted: ['이의제기를 접수했어요. 어드민이 검토할게요.', 'Dispute submitted. An admin will review it.', 'Đã gửi khiếu nại. Quản trị viên sẽ xem xét.', 'Спор отправлен. Администратор рассмотрит его.'],
  submitFail: ['이의제기 접수에 실패했어요.', 'Failed to submit dispute.', 'Gửi khiếu nại thất bại.', 'Не удалось отправить спор.'],
  creditsUnit: ['크레딧', 'credits', 'credit', 'кредитов'],
  pendingReview: ['어드민 검토 중이에요.', 'Under admin review.', 'Đang được quản trị viên xem xét.', 'На рассмотрении администратора.'],
  openBtn: ['이의제기', 'Dispute', 'Khiếu nại', 'Оспорить'],
  reasonLabel: ['사유', 'Reason', 'Lý do', 'Причина'],
  reasonPlaceholder: [
    '예: 업체가 응답 없이 방치했어요',
    'e.g. The business never responded',
    'VD: Cửa hàng không phản hồi',
    'напр. Бизнес не ответил',
  ],
  claimedBillLabel: ['실제 결제금액 (알고 있다면)', 'Actual bill amount (if known)', 'Số tiền thanh toán thực tế (nếu biết)', 'Фактическая сумма счёта (если известна)'],
  claimedBillPlaceholder: ['선택 입력', 'Optional', 'Tuỳ chọn', 'Необязательно'],
  submitBtn: ['이의제기 보내기', 'Submit dispute', 'Gửi khiếu nại', 'Отправить спор'],
};

const bizActiveExtra = {
  reportPrompt: ['신고 사유를 입력해 주세요', 'Please enter a reason for the report', 'Vui lòng nhập lý do báo cáo', 'Укажите причину жалобы'],
  reportSent: ['신고를 접수했어요.', 'Report submitted.', 'Đã gửi báo cáo.', 'Жалоба отправлена.'],
  reportFail: ['신고 접수에 실패했어요.', 'Failed to submit report.', 'Gửi báo cáo thất bại.', 'Не удалось отправить жалобу.'],
  reportBtn: ['신고', 'Report', 'Báo cáo', 'Пожаловаться'],
};

const adminCreatorsTab = {
  applications: ['신청 심사', 'Applications', 'Đăng ký', 'Заявки'],
  overview: ['전체 현황', 'Overview', 'Tổng quan', 'Обзор'],
  settlements: ['정산 요청', 'Payout requests', 'Yêu cầu thanh toán', 'Запросы на выплату'],
  ledger: ['세무 원장', 'Tax ledger', 'Sổ cái thuế', 'Налоговый реестр'],
  disputes: ['이의제기', 'Disputes', 'Khiếu nại', 'Споры'],
  reports: ['신고', 'Reports', 'Báo cáo', 'Жалобы'],
};

const adminLedgerType = {
  creator_settlement: ['크리에이터 정산', 'Creator payout', 'Thanh toán creator', 'Выплата создателю'],
  business_subscription: ['업체 구독료 매출', 'Business subscription revenue', 'Doanh thu gói đăng ký', 'Доход от подписки бизнеса'],
  business_commission: ['업체 수수료 매출', 'Business commission revenue', 'Doanh thu hoa hồng', 'Доход от комиссии бизнеса'],
  platform_other_revenue: ['플랫폼 기타 매출', 'Other platform revenue', 'Doanh thu khác của nền tảng', 'Прочий доход платформы'],
  platform_expense: ['플랫폼 비용', 'Platform expense', 'Chi phí nền tảng', 'Расходы платформы'],
};

const adminClassification = {
  undetermined: ['미정', 'Undetermined', 'Chưa xác định', 'Не определено'],
  service: ['인적용역소득', 'Personal service income', 'Thu nhập dịch vụ cá nhân', 'Доход от личных услуг'],
  royalty: ['사용료소득', 'Royalty income', 'Thu nhập bản quyền', 'Роялти'],
};

const adminCreatorsExtra = {
  classificationMemoPrompt: [
    '분류 근거 메모(선택) — 예: 거주국/조약/용역수행지 등',
    'Classification rationale (optional) — e.g. residency, treaty, place of service',
    'Ghi chú căn cứ phân loại (tuỳ chọn) — vd: nơi cư trú/hiệp định/nơi thực hiện dịch vụ',
    'Заметка об основании классификации (необязательно) — напр. резидентство, договор, место оказания услуги',
  ],
  disputeMemoPrompt: ['처리 메모(선택)', 'Resolution memo (optional)', 'Ghi chú xử lý (tuỳ chọn)', 'Заметка о решении (необязательно)'],
  disputeBillAmountPrompt: ['실제 청구금액 확정', 'Confirm final bill amount', 'Xác nhận số tiền thanh toán cuối cùng', 'Подтвердите итоговую сумму счёта'],
  confirmSuspendFromReport: ['이 신고로 크리에이터를 정지할까요?', 'Suspend this creator based on this report?', 'Đình chỉ creator này dựa trên báo cáo này?', 'Приостановить этого создателя на основании жалобы?'],
  reportNotePrompt: ['처리 메모(선택)', 'Resolution note (optional)', 'Ghi chú xử lý (tuỳ chọn)', 'Заметка о решении (необязательно)'],
  confirmSuspend: ['이 크리에이터를 정지할까요? 활성 제휴가 모두 종료돼요.', 'Suspend this creator? All active partnerships will end.', 'Đình chỉ creator này? Tất cả hợp tác đang hoạt động sẽ kết thúc.', 'Приостановить этого создателя? Все активные партнёрства будут завершены.'],
  suspendReasonPrompt: ['정지 사유(선택)', 'Suspension reason (optional)', 'Lý do đình chỉ (tuỳ chọn)', 'Причина приостановки (необязательно)'],
  reinstateBtn: ['정지 해제', 'Reinstate', 'Khôi phục', 'Восстановить'],
  suspendBtn: ['정지', 'Suspend', 'Đình chỉ', 'Приостановить'],
  flaggedTitle: ['이상거래 검토', 'Flagged for review', 'Cần xem xét bất thường', 'Отмечено для проверки'],
  noFlagged: ['이상거래로 표시된 건이 없어요.', 'Nothing flagged.', 'Không có giao dịch nào được đánh dấu.', 'Ничего не отмечено.'],
  noDisputes: ['이의제기가 없어요.', 'No disputes.', 'Không có khiếu nại.', 'Нет споров.'],
  creatorClaimedBill: ['크리에이터가 신고한 금액: {amount}', "Creator's claimed amount: {amount}", 'Số tiền creator khai báo: {amount}', 'Сумма, заявленная создателем: {amount}'],
  disputeApproveBtn: ['이의제기 인정(지급)', 'Approve (pay out)', 'Chấp nhận (thanh toán)', 'Одобрить (выплатить)'],
  disputeRejectBtn: ['이의제기 기각', 'Reject dispute', 'Từ chối khiếu nại', 'Отклонить спор'],
  noReports: ['신고가 없어요.', 'No reports.', 'Không có báo cáo.', 'Нет жалоб.'],
  reportSuspendBtn: ['정지 처리', 'Suspend', 'Đình chỉ', 'Приостановить'],
  reportDismissBtn: ['기각', 'Dismiss', 'Bỏ qua', 'Отклонить'],
  businessNumberLabel: ['사업자등록번호', 'Business reg. number', 'Mã số ĐKKD', 'Номер регистрации'],
  businessNumberMissing: ['사업자정보 미등록', 'Business info not registered', 'Chưa đăng ký thông tin doanh nghiệp', 'Данные бизнеса не зарегистрированы'],
  noLedgerEntries: ['세무 원장 기록이 없어요.', 'No ledger entries.', 'Không có bản ghi sổ cái.', 'Нет записей в реестре.'],
  ledgerFormTitle: ['수동 기록 추가 (업체 구독료/수수료/플랫폼 매출·비용)', 'Add manual entry (subscription/commission/platform revenue or expense)', 'Thêm bản ghi thủ công (gói đăng ký/hoa hồng/doanh thu-chi phí nền tảng)', 'Добавить запись вручную (подписка/комиссия/доход-расход платформы)'],
  ledgerAmountPlaceholder: ['금액', 'Amount', 'Số tiền', 'Сумма'],
  ledgerBusinessIdPlaceholder: ['업체 ID(선택)', 'Business ID (optional)', 'ID doanh nghiệp (tuỳ chọn)', 'ID бизнеса (необязательно)'],
  ledgerDescPlaceholder: ['설명', 'Description', 'Mô tả', 'Описание'],
  ledgerMemoPlaceholder: ['메모(선택)', 'Memo (optional)', 'Ghi chú (tuỳ chọn)', 'Заметка (необязательно)'],
  ledgerSubmitBtn: ['기록 추가', 'Add entry', 'Thêm bản ghi', 'Добавить запись'],
  ledgerAmountRequired: ['금액을 입력해 주세요.', 'Please enter an amount.', 'Vui lòng nhập số tiền.', 'Пожалуйста, укажите сумму.'],
  ledgerFilterAll: ['전체', 'All', 'Tất cả', 'Все'],
  defaultRateLabel: ['플랫폼 기본 원천징수율', 'Default withholding rate', 'Tỷ lệ khấu trừ thuế mặc định', 'Стандартная ставка удержания налога'],
  defaultRateNote: [
    '오버라이드가 없는 모든 크리에이터에 적용돼요. 밍고 한국 사업자 기준 기본값은 3.3%(프리랜서 사업소득)예요.',
    'Applies to all creators without an individual override. Default is 3.3% (Korean freelance business income rate) since Mingo is a Korean business entity.',
    'Áp dụng cho tất cả creator không có ghi đè riêng. Mặc định là 3.3% (thuế thu nhập kinh doanh tự do ở Hàn Quốc) vì Mingo là pháp nhân Hàn Quốc.',
    'Применяется ко всем создателям без индивидуального переопределения. По умолчанию 3.3% (ставка для фрилансеров в Корее), так как Mingo — корейское юрлицо.',
  ],
  saveBtn: ['저장', 'Save', 'Lưu', 'Сохранить'],
  useDefaultPlaceholder: ['기본값', 'Default', 'Mặc định', 'По умолчанию'],
  payoutCurrencyRequestedLabel: ['신청 통화:', 'Requested currency:', 'Đơn vị tiền tệ yêu cầu:', 'Запрошенная валюта:'],
  payoutAmountLabel: ['실지급액', 'Payout amount', 'Số tiền thực nhận', 'Сумма к выплате'],
  withholdingLabel: ['원천징수', 'Withholding', 'Khấu trừ thuế', 'Удержанный налог'],
  ledgerExportBtn: ['엑셀로 내보내기', 'Export to Excel', 'Xuất Excel', 'Экспорт в Excel'],
};

const adminFlagReason = {
  high_daily_volume: [
    '24시간 내 방문 확정 급증',
    'Sharp rise in confirmed visits within 24h',
    'Lượt ghé thăm xác nhận tăng đột biến trong 24 giờ',
    'Резкий рост подтверждённых визитов за 24 часа',
  ],
};

function buildLang(langIndex) {
  return {
    creator: {
      pageTitle: ['크리에이터', 'Creator', 'Người sáng tạo', 'Создатель'][langIndex],
      onboarding: { ...pick(onboarding, langIndex), type: pick(onboardingType, langIndex) },
      pending: pick(pending, langIndex),
      rejected: pick(rejected, langIndex),
      linkRequest: pick(linkRequest, langIndex),
      links: pick(links, langIndex),
      linkStatus: pick(linkStatus, langIndex),
      earnings: pick(earnings, langIndex),
      settlement: { ...pick(settlementNs, langIndex), status: pick(settlementStatus, langIndex) },
      qrLanding: pick(qrLanding, langIndex),
      suspended: pick(suspendedNs, langIndex),
      claimStatus: pick(claimStatus, langIndex),
      dispute: pick(dispute, langIndex),
    },
    bizCreator: {
      menuLabel: ['크리에이터 제휴', 'Creator partnerships', 'Hợp tác creator', 'Партнёрство с создателями'][langIndex],
      summary: pick(bizSummary, langIndex),
      requests: pick(bizRequests, langIndex),
      claims: pick(bizClaims, langIndex),
      active: { ...pick(bizActive, langIndex), ...pick(bizActiveExtra, langIndex) },
      profile: pick(bizProfile, langIndex),
    },
    admin: {
      nav: {
        creators: ['크리에이터', 'Creators', 'Người sáng tạo', 'Создатели'][langIndex],
      },
      creators: {
        ...pick(adminCreators, langIndex),
        ...pick(adminCreatorsExtra, langIndex),
        tab: pick(adminCreatorsTab, langIndex),
        status: pick(adminCreatorStatus, langIndex),
        flagReason: pick(adminFlagReason, langIndex),
        ledgerType: pick(adminLedgerType, langIndex),
        classification: pick(adminClassification, langIndex),
      },
    },
  };
}

export const phaseCreatorCommissionKo = buildLang(0);
export const phaseCreatorCommissionEn = buildLang(1);
export const phaseCreatorCommissionVi = buildLang(2);
export const phaseCreatorCommissionRu = buildLang(3);
